var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("© Bestony 2019 "),_c('a',{attrs:{"href":"https://bitbear.net/?refcode=1ndyezv73","target":"_blank"}},[_vm._v("比特熊,微服务")])])}]

export { render, staticRenderFns }